import { betterAuthClient } from '@/lib/auth/better-auth-client'

export type HelmSessionUser = {
  id: string
  email?: string | null
  name?: string | null
}

export async function getHelmSessionUser(): Promise<HelmSessionUser | null> {
  const { data } = await betterAuthClient.getSession()
  const user = data?.user

  if (!user?.id) {
    return null
  }

  return {
    id: user.id,
    email: user.email,
    name: user.name,
  }
}

export function getMainSiteLoginUrl() {
  const mainSiteUrl = process.env.NEXT_PUBLIC_MAIN_SITE_URL || 'https://tarifix.xtellar.app'
  return `${mainSiteUrl}/login?redirect=helm`
}
